import { z } from 'zod';
import { NEW_DOMAIN_FLAG } from '../SelectDomain.queries.ts';

export const NEW_DOMAIN_NAME_ERR = {
  message: 'What new domain should be added?',
  path: ['domainName'],
};
export const INVALID_DOMAIN_NAME_ERR = {
  message: 'Please provide a fully-qualified domain name (e.g. example.com)',
  path: ['domainName'],
};

/** Domain-select fields shared by the admin and endpoint identity provider forms */
export const domainFieldsSchema = {
  domainID: z.string().refine((val) => val !== '', 'Please choose an option'),
  domainName: z.string().transform((val) => val.toLowerCase().trim()),
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- There's probably a more elegant way to do this, but it works
const domainFieldsObject = z.object(domainFieldsSchema);
type DomainFieldsData = z.infer<typeof domainFieldsObject>;

export function checkNewDomain(data: DomainFieldsData) {
  return data.domainID === NEW_DOMAIN_FLAG ? data.domainName.length > 0 : true;
}

export function checkDomainFormat(data: DomainFieldsData) {
  if (data.domainID === NEW_DOMAIN_FLAG) {
    return data.domainName.includes('.');
  }
  return true;
}
